import axios from 'axios'
import { TileWMS } from 'ol/source'
import {generateToken} from "@/services/map";
const riskData = require('../assets/risk-data.json')

const wmsSource = new TileWMS({
  url: 'proxy/geoserver/colorado/wms',
  params: {
    LAYERS: 'colorado:WildfireRiskIndex',
    QUERY_LAYERS: 'colorado:WildfireRiskIndex',
    SRS: 'EPSG:3857'
  },
  serverType: 'geoserver',
  crossOrigin: 'anonymous'
})

function getEsriGeometryType (geojsonFeature) {
  return 'esriGeometry' + geojsonFeature.geometry.type
}

export function geojsonToEsri (geojsonFeature, spatialReferenceNumber = 3857) {
  const esriGeometryType = getEsriGeometryType(geojsonFeature)
  const geometry = geojsonFeature.geometry.coordinates
  switch (esriGeometryType) {
    case 'esriGeometryPoint':
      return { x: geometry[0], y: geometry[1] }
    case 'esriGeometryMultipoint':
      return { points: geometry }
    case 'esriGeometryPolygon':
      return { rings: geometry }
    case 'esriGeometryPolyline':
      return { paths: geometry }
    case 'esriGeometryEnvelope':
      return {
        xmin: geometry[0][0][0],
        ymin: geometry[0][0][1],
        xmax: geometry[0][1][0],
        ymax: geometry[0][1][1],
        spatialReference: { wkid: spatialReferenceNumber }
      }
  }
}

function buildLayers (layers) {
  const stringLayers = layers.join(',')
  return `top:${stringLayers}`
}

export async function arcgisIdentifyService ({
                                               geojson, mapExtent, imageDisplay, refreshToken = false, spatialReferenceCode = '102100',
                                               tolerance = '0.25', returnGeometry = 'false', f = 'pjson',
                                               archived = false, layers = [43]
                                             }) {

  // Uses proxy
  const layer = 'https://gisus.technosylva.com/arcgis/rest/services/I2204/COWRA2022_CFA_otherlayers/MapServer/identify'
  // Form
  const params = new URLSearchParams()
  // Required fields
  params.append('geometryType', getEsriGeometryType(geojson))
  params.append('geometry', JSON.stringify(geojsonToEsri(geojson)))
  params.append('mapExtent', mapExtent)
  params.append('imageDisplay', imageDisplay)
  params.append('layers', buildLayers(layers))
  params.append('tolerance', tolerance)
  params.append('returnGeometry', returnGeometry)
  params.append('sr', spatialReferenceCode)
  params.append('f', f)

  // Get token
  let identifyToken = localStorage.getItem('identifyToken')

  if (refreshToken || !identifyToken) {
    identifyToken = await generateToken()
    localStorage.setItem('identifyToken', identifyToken)
    refreshToken = false
  }

  params.append('token', identifyToken)

  // Add auth header
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    params: params
  }


  // Do identify to mapping service
  const res = await axios.get(layer, config)
  if (res.data.error && res.data.error.code === 498 && !refreshToken) {
    await arcgisIdentifyService({
      geojson, mapExtent, imageDisplay, refreshToken: true, spatialReferenceCode, layers, tolerance, returnGeometry, f, archived })
  }
  if (res.data.results.length) {
    return riskData.values[parseInt(res.data.results[0].attributes["Raster.Value"])]
  }

  return null
}
